export const widgetLanguages = {
    de: '276',
    en: '274',
    es: '278',
    pl: '279',
    ru: '275',
};
